/* eslint-disable */
// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import * as React from 'react';
import { Query } from 'react-apollo';

import cx from 'classnames';

import GridApi from '../../components/GridApi';
import PageContainer from '../../components/PageContainer';
import ActionsHeader from '../../components/ActionsHeader';
import ModuleQuery from '../../components/ModuleQuery';
import Row from '../../components/Row';
import Col from '../../components/Col';
import Notifications from '../../components/Notifications';
import ContentChecker from '../../components/ContentChecker';
import FullSizeCenteredContent from '../../components/FullSizeCenteredContent';
import Loader from '../../components/Loading';
import GridApiController from '../../controllers/GridApiController';
import userSettingsQuery from '../../graphql/queries/userSettings.query';
import moduleDataQuery from '../../graphql/queries/savedOrdersData.query';
import ActionsOrganizer from './components/ActionsOrganizer';
import { OrderContentConsumer } from '../../context/orderContent.context';
import { getDefaultUserSettings } from '../../utils'

type Props = {
  isFullPage?: boolean,
  size?: string,
  showGroupPanel?: boolean,
  paginated?: boolean,
};

export default class App extends React.Component<Props> {
  moduleName = 'savedOrders';

  static defaultProps = {
    isFullPage: false,
    size: 'small',
    showGroupPanel: true,
    paginated: false,
  };

  render() {

    return (
      <PageContainer
        className={cx({
          'page--is-full-page': this.props.isFullPage,
          'page--is-nested': !this.props.isFullPage,
          [`page--size-${this.props.size || ''}`]: this.props.size,
        })}
        isFullPage={this.props.isFullPage}
        size={this.props.size}
      >
        <OrderContentConsumer>
          {({ onChangeOrderItems, clearSelectedOrderType }: any) => {
            return (
              <ModuleQuery
                query={moduleDataQuery}
                variables={{
                  moduleName: this.moduleName,
                }}
              >
                {({
                  data: moduleData,
                  loading: moduleLoading,
                  refetch: moduleRefetch,
                  refetching: moduleRefetching,
                  refetched: moduleRefetched,
                }) => (
                  <Query
                    query={userSettingsQuery}
                    variables={{
                      moduleName: this.moduleName,
                    }}
                  >
                    {({ data: dataGrid, loading }: any) => {
                      if (loading || !dataGrid) {
                        return (
                          <FullSizeCenteredContent>
                            <Loader />
                          </FullSizeCenteredContent>
                        );
                      }

                      const userSettings =
                        dataGrid && dataGrid.userSettings
                          ? {
                              columnsMapping: dataGrid.userSettings.columns,
                              frozenColumns:
                                dataGrid.userSettings.frozenColumns,
                              groups: dataGrid.userSettings.groups,
                              sorting: dataGrid.userSettings.sorting,
                            }
                          : {};

                      const defaultUserSettings = getDefaultUserSettings(dataGrid)

                      return (
                        <GridApiController
                          data={moduleData.savedOrdersContent}
                          loading={loading || moduleLoading}
                          refetching={moduleRefetching}
                          refetched={moduleRefetched}
                          refetch={moduleRefetch}
                          defaultColumns={dataGrid.defaultColumns}
                          defaultSorting={dataGrid.defaultSorting}
                          onChangeOrderItems={onChangeOrderItems}
                          defaultGroupPanels={dataGrid.defaultGroupPanels}
                          paginated={this.props.paginated}
                          {...userSettings}
                        >
                          {({
                            selectedItems,
                            gridUpdated,
                            collection,
                            columnsMapping,
                            currentItem,
                            onGridUpdated,
                            onGridWillUnmount,
                            onGridRef,
                            onColSorted,
                            onColResized,
                            onColDragged,
                            onColFreezed,
                            onRowFreezed,
                            onRowSelected,
                            onColumnsMappingChange,
                            onCurrentItemChanged,
                            onGroupPanelChanged,
                            onOrderActivated,
                            onClearSelection,
                            onNotesSaved,
                            saveStatus,
                            orderActiveStatus,
                            onViewSaved,
                            onViewReset,
                            grid,
                            userViewState,
                            refetching,
                            hasAllColumnsHidden,
                            frozenColumns,
                            refetch,
                            isLoading,
                            isRefetching,
                            hasDataToDisplay,
                            clearCollectionAndResetChangedOrderItems,
                            playResetAnimation,
                            handleResetAnimation,
                            setFlexGridFilter,
                            clearInternalFilters,
                            toggleMultiSort,
                            multiColumnSort
                          }) => (
                            <React.Fragment>
                              <Notifications
                                orderActiveStatus={orderActiveStatus}
                                saveStatus={saveStatus}
                              />
                              <ActionsHeader
                                grid={grid}
                                collection={collection}
                                defaultColumnsMapping={dataGrid.defaultColumns}
                                columnsMapping={columnsMapping}
                                selectedItems={selectedItems}
                                moduleName={this.moduleName}
                                saveStatus={saveStatus}
                                loading={isLoading || isRefetching}
                                onViewSaved={onViewSaved}
                                onViewReset={onViewReset}
                                onNotesSaved={onNotesSaved}
                                onColumnsMappingChange={onColumnsMappingChange}
                                userViewState={userViewState}
                                refetch={refetch}
                                hasAllColumnsHidden={hasAllColumnsHidden}
                                hasDataToDisplay={hasDataToDisplay}
                                frozenColumns={frozenColumns}
                                currentItem={currentItem}
                                orderActiveStatus={orderActiveStatus}
                                onOrderActivated={onOrderActivated}
                                defaultSettings={defaultUserSettings}
                                handleResetAnimation={handleResetAnimation}
                                useLegacyColumnsManager={true}
                                toggleMultiSort={toggleMultiSort}
                                multiColumnSort={multiColumnSort}
                              >
                                {actions => (
                                  <Row
                                    css={{
                                      justifyContent: 'space-between',
                                      padding: '0 10px',
                                    }}
                                  >
                                    <Col>
                                      <ActionsOrganizer
                                        minHeight="80px"
                                        clearCollectionAndResetChangedOrderItems={
                                          clearCollectionAndResetChangedOrderItems
                                        }
                                        clearInternalFilters={clearInternalFilters}
                                        {...actions}
                                        toggleMultiSort={toggleMultiSort}
                                      />
                                    </Col>
                                  </Row>
                                )}
                              </ActionsHeader>
                              <ContentChecker
                                isLoading={isLoading}
                                isRefetching={isRefetching}
                                hasAllColumnsHidden={hasAllColumnsHidden}
                                hasDataToDisplay={hasDataToDisplay}
                                collection={collection}
                              >
                                {() => (
                                  <React.Fragment>
                                    <GridApi
                                      collection={collection}
                                      columnsMapping={columnsMapping}
                                      onRowSelected={onRowSelected}
                                      onColSorted={onColSorted}
                                      onColResized={onColResized}
                                      onColDragged={onColDragged}
                                      onColFreezed={onColFreezed}
                                      onRowFreezed={onRowFreezed}
                                      onGridUpdated={onGridUpdated}
                                      onGridWillUnmount={onGridWillUnmount}
                                      onCurrentItemChanged={
                                        onCurrentItemChanged
                                      }
                                      onGroupPanelChanged={onGroupPanelChanged}
                                      onClearSelection={onClearSelection}
                                      ref={onGridRef}
                                      refetching={isRefetching}
                                      hasAllColumnsHidden={hasAllColumnsHidden}
                                      hasDataToDisplay={hasDataToDisplay}
                                      showFrozenBars={false}
                                      isFullPage={this.props.isFullPage}
                                      showGroupPanel={this.props.showGroupPanel}
                                      paginated={this.props.paginated}
                                      playResetAnimation={playResetAnimation}
                                      setFlexGridFilter={setFlexGridFilter}
                                      multiColumnSort={multiColumnSort}
                                    />
                                  </React.Fragment>
                                )}
                              </ContentChecker>
                            </React.Fragment>
                          )}
                        </GridApiController>
                      );
                    }}
                  </Query>
                )}
              </ModuleQuery>
            );
          }}
        </OrderContentConsumer>
      </PageContainer>
    );
  }
}
